/* INTEGY V439 — specialist collection filter profiles.
   These six electronics/control collections intentionally bypass the universal
   RC-parts taxonomy. Their server-rendered, V37-backed options remain usable
   without JavaScript; this owner only groups approved options and removes any
   stale rows injected by cached/legacy markup. */
(function(){
  'use strict';

  function handle(value){
    return String(value||'').toLowerCase().replace(/&/g,' and ')
      .replace(/[^a-z0-9]+/g,'-').replace(/-+/g,'-').replace(/^-|-$/g,'');
  }
  function collectionHandle(){
    var match=String(location.pathname||'').match(/^\/collections\/([^\/?#]+)/i);
    return match?handle(decodeURIComponent(match[1])):'';
  }

  var profiles={
    'battery-plugs-meters-accessories-for-rc-cars-boats-planes-helicopters':{
      groups:[
        ['Product type',['connector','adapter','plug','wire','battery-straps-and-accessories','lipo-battery-bag','meters-and-accessories','voltage-checker-battery-tester','charger','soldering-jig']],
        ['Connector family',['xt60','xt90','t-plug','ec3','ec5','jst','banana-plug','bullet']],
        ['Offers',['clearance']]
      ]
    },
    'servos-digital-servos-for-rc-cars-boats-planes-helicopters':{
      groups:[
        ['Shop servo type',['digital-servo','high-voltage-servo','brushless-servo','low-profile-servo','micro-servo','high-torque-servo','crawler-servo']],
        ['Application',['1-10','1-7','crawler','drift','touring','rtr']],
        ['Color',['black','blue','red','silver','grey','orange']]
      ]
    },
    'custom-steering-wheels':{
      groups:[
        ['Product type',['steering-wheel','radio-steering-wheel']],
        ['Radio compatibility',['futaba','sanwa','airtronics','hitec','flysky','spektrum']],
        ['Color',['black','blue','red','silver','orange','yellow']]
      ]
    },
    'radio-controllers-tx-receivers-for-rc-cars-boats-planes-helicopters':{
      groups:[
        ['Product type',['radio','receiver']],
        ['Radio brand',['flysky','futaba']],
        ['Application',['rtr']],
        ['Color',['black','red','gold']]
      ]
    },
    'aluminum-servo-horn-for-rc-cars-boats-planes-helicopters':{
      groups:[
        ['Product type',['servo-horn','servo-saver','servo-mount']],
        ['Servo compatibility',['futaba','sanwa','hitec','3racing']],
        ['Color',['black','blue','red','silver','gunmetal','orange','purple','gold']],
        ['Offers',['clearance']]
      ]
    },
    'connectors-plugs-wires-for-rc-cars-helicopters-planes':{
      groups:[
        ['Product type',['connector','plug','wire','adapter','charger']],
        ['Connector family',['xt60','xt90','t-plug','ec3','ec5','jst','futaba','banana-plug','bullet']],
        ['Offers',['clearance']]
      ]
    }
  };

  var current=collectionHandle();
  if(!profiles[current]) return;
  // Executed before V298 because deferred scripts preserve document order.
  // V298 checks this flag and yields instead of rebuilding a universal list.
  window.INTEGY_V439_SPECIALTY_FILTER_PROFILE_ACTIVE=current;
  if(window.IntegyV439SpecialtyFilters) return;
  window.IntegyV439SpecialtyFilters=true;

  var observer=null;
  var observedRoot=null;
  var queued=0;
  var applying=false;

  function rowKey(row){
    return handle(row.getAttribute('data-tag-handle')||
      row.getAttribute('data-integy-v439-profile-key')||
      row.getAttribute('data-filter-handle')||'');
  }
  function rows(list){
    return Array.prototype.slice.call(list.querySelectorAll(
      '.integy-v353-static-filter-row,[data-integy-v439-direct-filter]'));
  }
  function allowedMap(profile){
    var output=Object.create(null);
    profile.groups.forEach(function(group){group[1].forEach(function(key){output[key]=true;});});
    return output;
  }
  function groupFor(profile,key){
    for(var index=0;index<profile.groups.length;index+=1){
      if(profile.groups[index][1].indexOf(key)!==-1) return profile.groups[index][0];
    }
    return '';
  }
  function beginChanges(){
    applying=true;
    if(observer) observer.disconnect();
  }
  function endChanges(){
    applying=false;
    if(observer&&observedRoot) observer.observe(observedRoot,{childList:true,subtree:true});
  }
  function apply(){
    var profile=profiles[current];
    var list=document.querySelector('[data-integy-v200-static-part-filter-list]');
    if(!profile||!list) return;

    beginChanges();
    try{
      document.documentElement.classList.add('integy-v439-specialty-filters','integy-v439-profile-'+current);
      var allowed=allowedMap(profile), kept=[];
      rows(list).forEach(function(row){
        var key=rowKey(row);
        if(!key||!allowed[key]){
          row.hidden=true;
          row.setAttribute('aria-hidden','true');
          return;
        }
        row.hidden=false;
        row.removeAttribute('aria-hidden');
        row.setAttribute('data-integy-v439-group',groupFor(profile,key));
        kept.push(row);
      });

      Array.prototype.slice.call(list.querySelectorAll('.integy-v439-filter-subheading')).forEach(function(node){node.remove();});
      var last='';
      kept.forEach(function(row){
        var group=row.getAttribute('data-integy-v439-group')||'';
        if(group&&group!==last){
          var heading=document.createElement('div');
          heading.className='integy-v439-filter-subheading';
          heading.textContent=group;
          list.insertBefore(heading,row);
          last=group;
        }
      });

      var helper=document.querySelector('.integy-v200-static-filter-shell .integy-sidebar-helper');
      if(helper&&/part type, scale, color/i.test(helper.textContent||'')){
        helper.textContent='Use the collection-specific options below to narrow these products.';
      }
      list.setAttribute('data-integy-v439-profile-applied',current);
    }finally{
      endChanges();
    }
  }
  function queue(){
    if(applying) return;
    clearTimeout(queued);
    queued=setTimeout(apply,90);
  }
  function startObserver(){
    observedRoot=document.querySelector('.productgrid--outer')||document.body;
    if(observedRoot&&window.MutationObserver){
      observer=new MutationObserver(queue);
      observer.observe(observedRoot,{childList:true,subtree:true});
    }
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){apply();startObserver();},{once:true});
  }else{
    apply();startObserver();
  }
  window.addEventListener('pageshow',apply);
  document.addEventListener('shopify:section:load',queue);
})();
